import Button from 'components/ButtonDeprecated';
import Groups from 'collections/Groups';
import CopySubscriberDialog from './CopySubscriberDialog';
import ModalTrigger from 'components/ModalTrigger';
import PropTypes from 'prop-types';
import * as React from 'react';
import Relationship from 'entities/Relationship';
import cx from 'classnames';
import './styles/CopySubscriberButton.scss';

// @ts-expect-error ts-migrate(2304) FIXME: Cannot find name '$FlowFixMeProps'.
class CopySubscriberButton extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    relationship: PropTypes.instanceOf(Relationship).isRequired,
    size: PropTypes.oneOf(['normal', 'small']),
  };

  static defaultProps = {
    size: 'normal',
  };

  getUnjoinedOwnedGroups = () => {
    const { relationship } = this.props;
    const subscriptions = relationship.getSubscriptionsToMe();

    if (!this.props.groups) {
      return [];
    }

    return new Groups(
      // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'group' implicitly has an 'any' type.
      this.props.groups.filter((group) => {
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'subscription' implicitly has an 'any' t... Remove this comment to see the full error message
        return !subscriptions.some((subscription) => {
          return subscription.getGroupId() === group.id;
        });
      })
    );
  };

  renderCopySubscriberDialog = () => {
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ relationships: any[]; }' is not assignable... Remove this comment to see the full error message
    return <CopySubscriberDialog relationships={[this.props.relationship]} />;
  };

  render() {
    const unjoinedGroups = this.getUnjoinedOwnedGroups();
    const hasUnjoinedGroup = unjoinedGroups.length > 0;

    let tooltip;
    if (!hasUnjoinedGroup) {
      const { relationship } = this.props;
      const subscriber = relationship.getRelatedUser();
      const name = subscriber.getName();
      tooltip = `${name} has joined all of your classes.`;
    }

    let button = (
      <Button
        {...this.props}
        className={cx(
          'CopySubscriberButton',
          {
            'CopySubscriberButton-small': this.props.size === 'small',
            'CopySubscriberButton-disabled': !hasUnjoinedGroup,
          },
          this.props.className
        )}
        color="mascot"
        level="text"
        size="small"
        tooltip={tooltip}
        tooltipPlacement="bottom"
      >
        Add to a class
      </Button>
    );

    if (hasUnjoinedGroup) {
      button = <ModalTrigger modal={this.renderCopySubscriberDialog()}>{button}</ModalTrigger>;
    }

    return button;
  }
}

export default CopySubscriberButton;
